import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";
import { deleteLineOfBusiness } from "../../../../../actions/Utilities/LineOfBusiness";

const useDeactivateLineOfBusiness = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (ids: number[] | undefined) => deleteLineOfBusiness(ids),{
    onSuccess: () => {
      queryClient.invalidateQueries(["GetLicenseType"]);
      toast.fire(
        "Success",
        "Line of Business were deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Line of Business failed",
        "Server Error: Cannot deactivate Line of Business",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeactivateLineOfBusiness;
